import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import { DEBUG_SKIP_AUTH } from './config/debug';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import TrackUpload from './pages/TrackUpload';
import Submissions from './pages/Submissions';
import Profile from './pages/Profile';
import MasterTrackList from './pages/MasterTrackList';
import Artist from './pages/Artist';
import CreateArtist from './pages/CreateArtist';
import Approvals from './pages/Approvals';
import ArtistList from './pages/ArtistList';
import MusicPlayer from './components/MusicPlayer/MusicPlayer';
import SessionKeepAlive from './components/SessionKeepAlive';

function App() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="app-screen min-h-screen text-white font-inter flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gold-50"></div>
      </div>
    );
  }

  return (
    <div className="app-screen min-h-screen text-white font-inter">
      <Routes>
        <Route path="/login" element={
          isAuthenticated ? <Navigate to="/dashboard" replace /> : DEBUG_SKIP_AUTH ? <Navigate to="/" replace /> : <Login />
        } />
        <Route path="/" element={
          isAuthenticated ? <Layout /> : DEBUG_SKIP_AUTH ? <Login /> : <Navigate to="/login" replace />
        }>
          <Route index element={<Navigate to="/dashboard" />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="upload" element={<TrackUpload />} />
          <Route path="batch" element={<Navigate to="/upload" replace />} />
          <Route path="submissions" element={<Submissions />} />
          <Route path="profile" element={<Profile />} />
          <Route path="master-tracks" element={<MasterTrackList />} />
          <Route path="approvals" element={<Approvals />} />
          <Route path="artist-list" element={<ArtistList />} />
          <Route path="artist/:artistId" element={<Artist />} />
          <Route path="create-artist" element={<CreateArtist />} />
        </Route>
      </Routes>
      
      {/* Music Player - only show when authenticated */}
      {isAuthenticated && (
        <>
          <SessionKeepAlive />
          <MusicPlayer />
        </>
      )}
    </div>
  );
}

export default App; 